import { render, staticRenderFns } from "./UiTable.vue?vue&type=template&id=065f657d&scoped=true&"
import script from "./UiTable.vue?vue&type=script&lang=js&"
export * from "./UiTable.vue?vue&type=script&lang=js&"
import style0 from "./UiTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UiTable.vue?vue&type=style&index=1&id=065f657d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f657d",
  null
  
)

export default component.exports